import React from 'react'
import Error from 'components/Error'
import langTranslate from 'locale'
import { ERROR_TYPE } from 'constants/error'

function ErrorBoundaryFallbackComponent(props) {
    const { title = 'Feature' } = props

    const onClickSearchAgain = () => {
        window.location.href = '/hotels'
    }

    return (
        <div className="flex flex-center align-middle my-15 px-8">
            <Error
                title={langTranslate('Whoops!')}
                subTitle="We are seeing overwhelming traffic. Please try again in sometime."
                buttonText="Try again"
                onButtonClick={e => onClickSearchAgain(e)}
                errorType={ERROR_TYPE.FAILURE}
            />
        </div>
    )
}

export default ErrorBoundaryFallbackComponent
